import React from "react";

import { PrintLabelButton } from "components/Picklist/common/PrintLabelButton";

export function PrintShippingLabelStep(props: { onClick: () => void }) {
  return <PrintLabelButton onClick={props.onClick}>Print Shipping Label</PrintLabelButton>;
}
